<template>
  <b-form-group>
    <label for="label">{{ label }}</label>
    <multiselect
      v-model="computedValue"
      :options="myOptions"
      :multiple="false"
      :close-on-select="true"
      :clear-on-select="false"
      :preserve-search="true"
      :placeholder="placeholder"
      label="name"
      track-by="id"
      selectLabel=""
      selectedLabel=""
      deselectLabel=""
      @select="callback"
    >
      <span slot="noResult">Nada encontrado</span>
    </multiselect>
  </b-form-group>
</template>

<script>
export default {
  props: [
    'name',
    'label',
    'placeholder',
    'value',
    'callback'
  ],
  data() {
    return {
      options: '',
      browser: null,
      browsers: [
        { id: '1', value: 'Chrome', name: 'Chrome' },
        { id: '2', value: 'Firefox', name: 'Firefox' },
        { id: '3', value: 'Safari', name: 'Safari' },
      ],
    }
  },
  computed: {
    myOptions() {
      if(!this.browsers.length)
        return []

      return [
        ...this.browsers,
        { name: "Todos", id: -1 }
      ]
    },
    computedValue() {
      if( typeof this.value === 'number' ){
        return this.browsers.find( c => c.id == this.value )
      } else {
        return this.value
      }
    }
  }
}
</script>

<style lang="scss">
  .form-group {
    margin-bottom: 0;
  }
</style>